// extracted by mini-css-extract-plugin
module.exports = {"home":"style_home__2Ant8","top":"style_top__3q1Q6"};